import type { App } from 'vue'
import * as ConstantHelper from './helper'

export default {
  install: (app: App) => {
    app.config.globalProperties.$c = ConstantHelper
  },
}
